import React from "react";
import { useSelector, useDispatch } from 'react-redux';
import { Link } from "react-router-dom";
import { toggleMenu } from '../../../store/slices/sidebarToggle';
import logo from '../../../images/CCImages/Conferlogo.png'
import logoText from '../../../images/CCImages/CCFabIcon.png';

const NavHader = () => {
   const sideMenu = useSelector(state => state.sidebarMenu);
   const { clinicInfo } = useSelector((state) => state.clinic);
   const dispatch = useDispatch();
   const handleToogle = () => {
      dispatch(toggleMenu());
   };
   return (
      <div className="nav-header">
         <Link to="/" className="brand-logo">
            {
               clinicInfo[0]?.hospitalInfo?.clinicSmallLogo ?
                  <img className="logo-abbr" src={clinicInfo[0]?.hospitalInfo?.clinicSmallLogo} alt="" /> :
                  <img className="logo-abbr" src={logoText} alt="" />
            }
            {
               clinicInfo[0]?.hospitalInfo?.headerLogo ?
                  <img className="logo-compact" src={clinicInfo[0]?.hospitalInfo?.headerLogo} alt="" /> :
                  <img className="logo-compact" src={logo} alt="" />
            }
            {
               clinicInfo[0]?.hospitalInfo?.headerLogo ?
                  <img className="brand-title" src={clinicInfo[0]?.hospitalInfo?.headerLogo} alt="" /> :
                  <img className="brand-title" src={logo} alt="" />
            }

         </Link>
         <div className="nav-control"
            onClick={() => {
               handleToogle()
            }}
         >
            <div className={`hamburger ${sideMenu ? "is-active" : ""}`}>
               <span className="line"></span>
               <span className="line"></span>
               <span className="line"></span>
            </div>
         </div>
      </div>
   );
};

export default NavHader;
